module.exports = __webpack_public_path__ + "img/logo.d4b88ee7.svg";